import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PushPipe } from '@ngrx/component';

import { ToggleSplitTypeButtonComponent } from '../../button/toggle-split-type-button/toggle-split-type-button.component';
import { CostElementsStatusBarComponent } from './cost-elements-status-bar.component';

@NgModule({
  declarations: [CostElementsStatusBarComponent],
  imports: [CommonModule, PushPipe, ToggleSplitTypeButtonComponent],
})
export class CostElementsStatusBarModule {}
